export default function capitalize(str) {
  return str.length > 0 && str[0].toUpperCase() + str.slice(1);
}
